export default {"src":"/_next/static/media/person_with_tie_64.081d075e.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};